import { render } from "./CustomTextArea.vue?vue&type=template&id=454d2a85&scoped=true&ts=true"
import script from "./CustomTextArea.vue?vue&type=script&lang=ts"
export * from "./CustomTextArea.vue?vue&type=script&lang=ts"

import "./CustomTextArea.vue?vue&type=style&index=0&id=454d2a85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454d2a85"]])

export default __exports__